import BaseRoute from "../../../lib/itn-ui-kit/route/base-route";
import { service } from "../../../lib/itn-ui-kit/services/service-container";

import Template from "./template";

export default class ProviderClientSearchRoute extends BaseRoute {
  @service("repositories/provider-client-status-repository") providerClientStatusRepository;

  element = (<Template />);

  async loader({ request }) {
    let data = [];
    let count = 0;

    try {
      const defaultParams = { limit: 25, offset: 0 };
      const url = new URL(request.url);
      const searchParams = Object.fromEntries(url.searchParams.entries());
      data = await this.providerClientStatusRepository.query({ ...defaultParams, ...searchParams });
      count = await this.providerClientStatusRepository.getTotalCount();
    } catch (error) {
      console.error("Error fetching provider-client-status data:", error);
      return error;
    }

    return {
      data,
      count,
    };
  }
}
